// extracted by mini-css-extract-plugin
module.exports = {"feature":"FeaturesTypeFirst_feature__36cNm","title":"FeaturesTypeFirst_title__f8ZB-"};